import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { saveRecord } from '../store/list/actions';
import { Store } from '@ngrx/store';
import { getErrors } from '../store/errors/selectors';

@Component({
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ record ? 'Modifica' : 'Nuovo' }} operatore</h4>
        </div>
        <div class="modal-body">

            <form [formGroup]="form" action="">

                <div *ngIf="errors && errors.message" class="alert alert-danger">{{ errors.message }}</div>
                <div class="form-group row">
                    <label class="col-form-label">Indirizzo email</label>
                    <div class="control-input">
                        <input class="form-control" type="email" formControlName="email"
                               name="email"
                               [ngClass]="{'is-invalid': errors?.email }">
                        <span *ngIf="errors?.email" class="invalid-feedback" role="alert">{{ errors?.email[0] }}</span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Nome</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="nome"
                               [ngClass]="{'is-invalid': errors?.nome }"
                               required>
                        <span *ngIf="errors?.nome" class="invalid-feedback" role="alert">{{ errors?.nome[0] }}</span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Cognome</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="cognome"
                               [ngClass]="{'is-invalid': errors?.cognome }"
                               required>
                        <span *ngIf="errors?.cognome"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.cognome[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Ragione sociale</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="company_name"
                               name="company_name"
                               [ngClass]="{'is-invalid': errors?.company_name }"
                               required>
                        <span *ngIf="errors?.company_name"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.company_name[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Codice fiscale</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="codice_fiscale"
                               name="codice_fiscale"
                               [ngClass]="{'is-invalid': errors?.codice_fiscale }"
                               required>
                        <span *ngIf="errors?.codice_fiscale"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.codice_fiscale[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Partita IVA</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="p_iva"
                               name="p_iva"
                               [ngClass]="{'is-invalid': errors?.p_iva }"
                               required>
                        <span *ngIf="errors?.p_iva"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.p_iva[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Indirizzo</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="address"
                               name="address"
                               [ngClass]="{'is-invalid': errors?.address }"
                               required>
                        <span *ngIf="errors?.address"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.address[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Comune</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="comune"
                               name="comune"
                               [ngClass]="{'is-invalid': errors?.comune }"
                               required>
                        <span *ngIf="errors?.comune"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.comune[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">CAP</label>
                    <div class="control-input">
                        <input class="form-control" type="number" formControlName="cap"
                               name="cap"
                               maxlength="5"
                               [ngClass]="{'is-invalid': errors?.cap }"
                               required>
                        <span *ngIf="errors?.cap"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.cap[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Provincia</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="provincia"
                               name="provincia"
                               maxlength="2"
                               [ngClass]="{'is-invalid': errors?.provincia }"
                               required>

                        <p class="form-text text-muted">Indicare la provincia con le due lettere (ad es. VR / VI /
                            PD...)</p>
                        <span *ngIf="errors?.provincia"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.provincia[0] }}
                </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Telefono</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="phone"
                               name="phone"
                               [ngClass]="{'is-invalid': errors?.phone }"
                               required>
                        <span *ngIf="errors?.phone"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.phone[0] }}
                </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p>Compilare indirizzo PEC oppure codice SDI per la fatturazione degli sms.</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label">PEC</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="pec"
                               name="pec"
                               [ngClass]="{'is-invalid': errors?.pec }">
                        <span *ngIf="errors?.pec"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.pec[0] }}
                </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label">SDI</label>
                    <div class="control-input">
                        <input class="form-control" type="text" formControlName="sdi"
                               name="sdi"
                               [ngClass]="{'is-invalid': errors?.sdi }">
                        <span *ngIf="errors?.sdi"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.sdi[0] }}
                </span>
                    </div>
                </div>
                <div class="form-group row" *ngIf="record">
                    <label class="col-form-label">Utente abilitato</label>
                    <div class="control-input">
                    <span class="switch">
                        <label>
                            <input name="enabled" formControlName="enabled" type="checkbox" checked="checked">
                            <span></span>
                        </label>
                    </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-form-label">Permessi</label>
                    <div class="control-input">
                        <div class="checkbox-list">
                            <div *ngFor="let permission of permissionsList; let i = index">
                                <label class="checkbox">
                                    <input [checked]="formPermissions.value.indexOf(permission.id) !== -1" (change)="permissionClickHandler($event)" type="checkbox" [value]="permission.id"> {{permission.value}}<span></span>
                                </label>
                            </div>
                        </div>

                        <span *ngIf="errors?.permissions"
                              class="invalid-feedback"
                              role="alert">
                    {{ errors?.permissions[0] }}
                    </span>

                    </div>
                </div>

              <div class="form-group row">
                <label class="col-form-label">Note</label>
                <div class="control-input">
                  <textarea name="note" formControlName="note" class="form-control"></textarea>
                </div>
              </div>
            </form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-default" (click)="modal.dismiss()">Chiudi</button>
            <button class="btn btn-primary" [disabled]="form.invalid" (click)="submitHandler($event)">Salva</button>
        </div>
    `
})

export class ItemModalComponent implements OnInit {
    public record = null;
    form: FormGroup;
    formPermissions: FormArray;
    permissionsList = [{
        id: 'clienti',
        value: 'Gestione clienti'
    }, {
        id: 'assistenza',
        value: 'Assistenza'
    }, {
        id: 'academy',
        value: 'Academy'
    }, {
        id: 'calendario',
        value: 'Calendario'
    }, {
        id: 'messaggistica',
        value: 'Messaggistica'
    }]
    errors = null;

    constructor(
        fb: FormBuilder,
        private store: Store,
        public modal: NgbActiveModal
    ) {

        this.form = fb.group({
            id: fb.control(null),
            nome: fb.control(null, [Validators.required]),
            cognome: fb.control(null, [Validators.required]),
            company_name: fb.control(null, [Validators.required]),
            codice_fiscale: fb.control(null, [Validators.required]),
            p_iva: fb.control(null, [Validators.required]),
            address: fb.control(null, [Validators.required]),
            comune: fb.control(null, [Validators.required]),
            provincia: fb.control(null, [Validators.maxLength(2)]),
            cap: fb.control(null, [Validators.maxLength(5), Validators.required]),
            phone: fb.control(null, [Validators.required]),
            email: fb.control(null, Validators.required),
            pec: fb.control(null, Validators.required),
            sdi: fb.control(null, Validators.required),
            permissions: fb.array([]),
            enabled: fb.control(true),
            note: fb.control(null)
        })

        const pecField = this.form.get('pec');
        const sdiField = this.form.get('sdi');

        pecField.valueChanges.subscribe(value => {
            const validator = sdiField.validator;
            if (value && validator) {
                sdiField.clearValidators();
                sdiField.updateValueAndValidity()
            } else if (!value && !validator) {
                sdiField.setValidators(Validators.required);
                sdiField.updateValueAndValidity()
            }

        })
        sdiField.valueChanges.subscribe(value => {
            const validator = pecField.validator;
            if (value && validator) {
                pecField.clearValidators();
                pecField.updateValueAndValidity()
            } else if (!value && !validator) {
                pecField.setValidators(Validators.required);
                pecField.updateValueAndValidity()
            }

        })

        this.formPermissions = this.form.controls.permissions as FormArray;

        this.store.select(getErrors).subscribe((errors) => this.errors = errors);

    }

    ngOnInit(): void {
        if (this.record) {
            this.form.patchValue(this.record);
            this.record.permissions.map(permission => {
                this.formPermissions.push(new FormControl(permission.name));
            })
        }
    }

    submitHandler(e) {
        const value = {
          ...this.form.value,
          id: this.record ? this.record.id : null
        }
        this.store.dispatch(saveRecord({record: value}))
    }

    permissionClickHandler(e) {
        const checkArray: FormArray = this.form.get('permissions') as FormArray;

        if (e.target.checked) {
            this.formPermissions.push(new FormControl(e.target.value));
        } else {
            let i: number = 0;
            this.formPermissions.controls.forEach((item: FormControl) => {
                if (item.value == e.target.value) {
                    this.formPermissions.removeAt(i);
                    return;
                }
                i++;
            });
        }
    }
}
